<template>
	<div id="page">

		<div class="page-content">
			<div class="fixed-top-box">
				<div class="page-title page-title-small">
					<h2 class="page-title-h2">
						<!--<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>-->
						چک لیست ها
						<!--<button data-menu="HelpMenu" class="position-static"><i class="fa fa-question-circle helpIco"></i></button>-->
					</h2>
					<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
					<button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
				</div>
				<div class="card header-card shape-rounded" data-card-height="100">
					<div class="card-overlay bg-highlight opacity-95"></div>
					<div class="card-overlay dark-mode-tint"></div>
				</div>
				<div class="card card-style mb-2">
					<div class="d-flex p-3">
						<div class="dropdown listType-dropdown">
							<button class="btn btn-xs rounded-m brand-bg-color ml-1" type="button" data-toggle="dropdown" aria-expanded="false" style="max-height:31px!important">
								<i class="fa fa-list text-white" :class="listType"></i>
							</button>

							<div class="dropdown-menu" style="transform:none!important">
								<button class="dropdown-item p-2 font-13" @click="changeListType('fa-list')">
									<i class="fa fa-list ml-2 brand-color"></i>
									نمایش چک لیست‌ها
								</button>
								<button class="dropdown-item p-2 font-13" @click="changeListType('fa-list-alt')">
									<i class="fa fa-list-alt ml-2 brand-color"></i>
									نمایش آیتم‌های چک لیست
								</button>
							</div>
						</div>
						<div v-if="listType == 'fa-list'" class="d-flex">
							<button id="filterBtn" type="button" class="btn btn-xs rounded-m brand-bg-color ml-1" data-toggle="modal" data-target="#searchModal" style="max-height:31px!important">
								<i class="fa fa-filter text-white"></i>
							</button>
							<div class="filter-row-scrollable">
								<div @click="lstFilter('all','all')" id="all" class="filterSelectItem filter-scrollable-box selected">همه</div>
								<div @click="lstFilter('unpassed','unpassed')" id="unpassed" class="filterSelectItem filter-scrollable-box ">جاری</div>
								<div @click="lstFilter('passed','passed')" id="passed" class="filterSelectItem filter-scrollable-box">بسته شده</div>
							</div>
						</div>

						<div v-else-if="listType == 'fa-list-alt'" class="d-flex align-items-center">
							<div class="custom-control ios-switch mr-4" style="zoom:85%">
								<input type="checkbox" @change="LoadWallData" v-model="isPassed" class="ios-input" id="checklistDone">
								<label class="custom-control-label" for="checklistDone"></label>
							</div>
							<span class="font-weight-bold" style="margin-right:35px">انجام شده ها</span>
						</div>
					</div>
					<!--<div class="row m-0 p-3">
						<div class="col-6 pr-0 pl-1">
							<div class="input-style input-style-2 input-required has-icon m-0">
								<i class="input-icon fa fa-filter color-orange-dark"></i>
								<em><i class="fa fa-angle-down"></i></em>
								<select @change="filterList" v-model="type" class="form-control">
									<option value="unpassed">جاری</option>
									<option value="passed">بسته شده</option>
									<option value="all" selected>همه</option>
								</select>
							</div>
						</div>
					</div>-->
				</div>
			</div>
			<span data-menu="menu-language" class="optionMenu"></span>
			<div v-if="true" class="main-content-box">
				<div v-if="listType == 'fa-list'">
					<div class="card card-style mb-2" @click.prevent="openDetails(task.checkListId)" v-for="task in CheckListList" :key="task.checkListId">
						<div class="list-group list-custom-small list-icon-0">
							<div class="list-group-div py-2 px-3">
								<div>
									<b class="font-13 text-dark">{{task.subject}}</b>
								</div>
								<div>
									<span class="text-muted d-inline-block text-left ltr">{{task.checkListDate}}</span>
									<span class="badge bg-magenta2-light font-10 mt-1 float-left">{{task.passedRate}} %</span>
								</div>
								<div class="d-flex justify-content-between">									
									<div style="width:90%" class="d-inline-flex align-items-center">

										<!--اگر کاربر چک لیست تصویر پروفایل نداشت-->
										<!--<i class="fa fa-user color-green2-light ml-0"></i>-->
										<!--تصویر کاربر چک لیست-->
										<img v-if="task.userImg!=null && task.userImg!=''" :src="task.userImg" alt="userProfileImg" width="30" height="30" class="rounded-circle ml-2 img-object-fit" />
										<i v-else class="fa fa-user-circle color-green2-light font-30 ml-2"></i>
										
										<span class="userTitle">{{task.userTitle}}</span>
									</div>


									<span class="text-left" style="width:10%" @click.stop="showMenu(task.checkListId,null)"><i class="fa fa-ellipsis-v font-14 ml-0"></i></span>
								</div>
							</div>
						</div>
					</div>
					<div class="card card-style" v-if="CheckListList.length==0 && Loading==false">
						<div class="content">
							<div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
							<p class="text-center py-3">چک لیستی یافت نشد.</p>
						</div>
					</div>
				</div>
				<div v-else-if="listType == 'fa-list-alt'">
					<div class="card card-style mb-2" :id="item.checkListFolderId" v-for="item in WallCheckListList" :key="item.checkListFolderId">
						<div class="list-group list-custom-small list-icon-0">
							<div class="list-group-div py-2 px-3">
								<div class="checkbox-Row">
									<input class="medium-checkbox" type="checkbox" :id="item.checkListFolderId" :checked="item.passed" @change="SavePassedValue(item)" />

									<b class="font-13 text-dark mr-3">{{item.subject}}</b>
								</div>
								<div v-if="item.abstractDesc!=null && item.abstractDesc!=''">
									<span class="text-muted">{{item.abstractDesc}}</span>
								</div>
								<div class="d-flex justify-content-between">
									<div>
										<span class="d-inline-block ltr">
											{{item.checkListDate}}
											<span v-if="item.reminderTimeFa!=null && item.reminderTimeFa!=''"> -{{item.reminderTimeFa}}</span>
											<img v-if="item.reminderTimeFa!=null && item.reminderTimeFa!=''" class="loginPageSlide-img ml-2" src="/assets/images/icons/reminder.gif" width="15" height="15" />
										</span>
									</div>
									<span class="text-left" style="width:10%" @click.stop="showMenu(item.checkListId,item.checkListFolderId)"><i class="fa fa-ellipsis-v font-14 ml-0"></i></span>
								</div>
							</div>
						</div>
					</div>

					<div class="card card-style" v-if="WallCheckListList.length==0 && Loading==false">
						<div class="content">
							<div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
							<p class="text-center py-3">چک لیستی یافت نشد.</p>
						</div>
					</div>
				</div>
				<div class="card card-style" v-if="listType == 'fa-list' && Loading==false && NoMoreData==false && CheckListList.length>0 && CheckListList.length%10==0">
					<div class="content">
						<div class="d-flex justify-content-center w-100">
							<button class="btn btn-outline-info rounded-m" @click="getNextPageForCheckListList">نمایش بیشتر</button>
						</div>
					</div>
				</div>

				<!--<div class="card card-style" v-if="Loading">
					<div class="content">
						<div class="d-flex justify-content-center w-100">
							<div class="spinner-border color-magenta2-dark" role="status"></div>
						</div>
					</div>
				</div>-->


			</div>

			<div class="card card-style" v-else>
				<div class="content">
					<h4 class="mb-0 text-center">تصاویر بخش چک لیست ها</h4>
				</div>
				<div class="divider mb-0"></div>
				<div class="gallery-view-controls d-flex justify-content-center">
					<a href="#" class="gallery-view-1-activate"><i class="fa fa-th"></i></a>
					<a href="#" class="gallery-view-2-activate color-highlight"><i class="fa fa-th-large"></i></a>
					<div class="clearfix"></div>
				</div>
				<div class="content my-n1">
					<div class="gallery-views gallery-view-2">
						<a data-lightbox="gallery-1" href="/assets/images/gallery/checkList-1-L.jpg" title="چک لیست های من" class="default-link">
							<img src="/assets/images/gallery/checkList-1-500x500.jpg" data-src="/assets/images/gallery/checkList-1-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
							<div class="caption">
								<h4 class="color-theme">چک لیست های من</h4>
								<div class="divider bottom-0"></div>
							</div>
						</a>
						<a data-lightbox="gallery-1" href="/assets/images/gallery/checkList-2-L.jpg" title="انتخاب نوع نمایش چک لیست ها" class="default-link">
							<img src="/assets/images/gallery/checkList-2-500x500.jpg" data-src="/assets/images/gallery/checkList-2-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
							<div class="caption">
								<h4 class="color-theme">انتخاب نوع نمایش چک لیست ها</h4>
								<div class="divider bottom-0"></div>
							</div>
						</a>
						<a data-lightbox="gallery-1" href="/assets/images/gallery/checkList-3-L.jpg" title="لیست کارهای هر چک لیست" class="default-link">
							<img src="/assets/images/gallery/checkList-3-500x500.jpg" data-src="/assets/images/gallery/checkList-3-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
							<div class="caption">
								<h4 class="color-theme">لیست کارهای هر چک لیست</h4>
								<div class="divider bottom-0"></div>
							</div>
						</a>
						<a data-lightbox="gallery-1" href="/assets/images/gallery/checkList-4-L.jpg" title="ثبت یادآور برای هر یک از کارهای چک لیست" class="default-link">
							<img src="/assets/images/gallery/checkList-4-500x500.jpg" data-src="/assets/images/gallery/checkList-4-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
							<div class="caption">
								<h4 class="color-theme">ثبت یادآور برای هر یک از کارهای چک لیست</h4>
								<div class="divider bottom-0"></div>
							</div>
						</a>
					</div>
				</div>

				<a href="/order" class="btn btn-l btn-icon bg-green2-dark rounded-s shadow-s btn-full btn-margins font-900 text-uppercase text-left mt-3"><i class="fa fa-credit-card text-center"></i>خرید اشتراک اپلیکیشن</a>
			</div>


		</div>
		<transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
			<div v-show="pageLoaded==true" class="addBtn" id="addBtn" ref="addBtn" v-if="isFreeRegist!==true">
				<div v-if="listType=='fa-list'">
					<router-link to="/CreateCheckList">
						<div class="icon icon-m rounded-m color-white bg-green2-light">
							<i class="fa fa-plus"></i>
						</div>
					</router-link>
				</div>
				<div v-else-if="listType == 'fa-list-alt'">
					<button @click="OpenCreateCheckListModal" class="btn btn-link">
						<div class="icon icon-m rounded-m color-white bg-green2-light">
							<i class="fa fa-plus"></i>
						</div>
					</button>
				</div>
			</div>
		</transition>

		<div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
			<div class="m-3">
				<div class="list-group list-custom-small">
					<router-link :to="{ name: 'CreateCheckList', params: { checkListId: selectedWorkId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-search color-green2-light float-right font-14"></i>مشاهده</span><i class="fa fa-angle-left"></i></router-link>
					<button v-if="listType == 'fa-list'" @click="Share" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-share-alt text-warning float-right font-14"></i>اشتراک گذاری</span><i class="fa fa-angle-left"></i></button>
					<button v-if="listType == 'fa-list'" @click.prevent="copyCheckList" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-copy color-magenta2-dark float-right font-14"></i>کپی</span><i class="fa fa-angle-left"></i></button>
					<button v-if="listType == 'fa-list'" @click.prevent="deleteCheckList" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></button>
					<button v-if="listType == 'fa-list-alt'" @click.prevent="deleteCheckListFolder" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></button>
				</div>
				<div class="clear"></div>
			</div>
		</div>
		<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
			<div v-if="pageLoading" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
			</div>
		</transition>
		<div id="searchModal" class="modal fade" role="dialog">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header align-items-center">
						<h4 class="modal-title mt-0">جستجو</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body m-0">
						<div class="w-100 search-box rounded-m position-relative mb-3">
							<i class="fa fa-search pr-3"></i>
							<input type="text" class="border-0" placeholder="جستجو ..." data-search="" v-model="searchKey" @change="filterList">
						</div>

						<myTeamList txtPlaceholder="کاربران" class="mb-3" @selectUser="selectUser"></myTeamList>

						<projects class="mb-3" @selectProject="selectProject"></projects>

						<calendar-filter class="filterCalendar" @selectDate="selectDate"></calendar-filter>

						<button @click="filterList" type="button" class="btn btn-xxs mt-3 btn-full bg-green1-dark rounded-sm font-900 w-100" data-dismiss="modal">
							<i class="fa fa-search ml-2"></i>
							جستجو
						</button>
					</div>
				</div>
			</div>
		</div>
		<Help-Menu title="راهنمای ثبت چک لیست" keyEn="TaskList"></Help-Menu>
		<my-tour></my-tour>
		<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
			<div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
			</div>
		</transition>
	</div>
	<Create-CheckList v-if="openCreateCheckListModal" :Expired="isExpired" :Passed="isPassed" @close="CloseCreateCheckListModal"></Create-CheckList>

</template>

<script>
	import calendarFilter from '../Components/CalendarFilter.vue';
	import myTour from '../Tours/CheckListTour.vue'
	import HelpMenu from '../Components/HelpMenu.vue';
	import VueSimpleAlert from "vue3-simple-alert";
	import ProjectList from '../Components/ProjectList.vue';
	import MyTeamList from '../Components/MyTeamList.vue';
	import CreateCheckList from '../Components/CreateCheckList.vue';
	import { useCookies } from "vue3-cookies";
	const { cookies } = useCookies();
	export default {
		components: {
			"calendar-filter": calendarFilter,
			"projects": ProjectList,
			"myTeamList": MyTeamList,
			"Help-Menu": HelpMenu,
			"Create-CheckList": CreateCheckList,
			myTour
		},

		data() {
			return {
				page: 1,
				filterId: 0,
				listType: "fa-list",
				isPassed: false,
				searchKey: "",
				type: "all",
				openCreateCheckListModal: false,
				selectedWorkId: 0,
				selectedFolcedrId: 0,
				pageLoaded: false,
				isExpired: true,
				pageLoading: false,
				userId: null,
				projectId: null,
				date: null
			};
		},
		computed: {
			CheckListList() {
				return this.$store.getters.GetCheckListList;
			},
			WallCheckListList() {
				return this.$store.getters.GetWallCheckListList;
			},
			Loading() {
				return this.$store.getters.GetLoading;
			},
			NoMoreData() {
				return this.$store.getters.GetCheckListNoMoreData;
			},
			isFreeRegist() {
				return this.$store.getters.GetIsFreeRegist;
			},
			UpdateCheckListList() {
				return this.$store.getters.GetUpdateCheckListList;
			},
		},
		created() {
			if (this.listType == "fa-list" || this.listType == null || this.listType == "") {
				this.$store.dispatch("GetCheckListListFromServer", {
					pageId: this.page,
					filterId: this.filterId,
					userId: this.userId,
					projectId: this.projectId,
					searchKey: this.searchKey,
					date: this.date
				});
			} else if (this.listType == "fa-list-alt") {
				this.$store.dispatch("GetWallCheckListListFromServer", {
					isPassed: this.isPassed,
				});
			}
			this.$http.get("Task/TaskOnline_GetUserActiveStatus")
				.then(data => {
					this.isExpired = data.data.expired;
				});
		},
		methods: {
			changeListType(type) {
				cookies.set("checkListShowType", type, "1000d");
				window.location.reload();
			},
			CloseCreateCheckListModal() {
				this.openCreateCheckListModal = false;
			},
			OpenCreateCheckListModal() {
				this.openCreateCheckListModal = true;
			},
			lstFilter(filterSelect, type) {
				this.type = type;
				var elements = document.getElementsByClassName('filterSelectItem');
				for (var i = 0; i < elements.length; i++) {
					elements[i].classList.remove('selected');
				}
				document.getElementById(filterSelect).classList.add('selected');
				this.filterList();
			},
			showAddButton() {
				this.pageLoaded = true;

			},
			selectProject(d) {
				this.projectId = d;
			},
			selectUser(d) {
				this.userId = d;
			},
			showMenu(checkListId, selectedFolcedrId = null) {
				this.selectedWorkId = checkListId;
				this.selectedFolcedrId = selectedFolcedrId;
				document.getElementsByClassName("optionMenu")[0].click();
			},
			filterList() {
				this.page = 1;
				if (this.listType == "fa-list" || this.listType == null || this.listType == "") {
					this.$store.dispatch("GetCheckListListFromServer", {
						pageId: this.page,
						filterId: this.filterId,
						searchKey: this.searchKey,
						userId: this.userId,
						projectId: this.projectId,
						date: this.date,
						type: this.type
					});
				} else if (this.listType == "fa-list-alt") {
					this.$store.dispatch("GetWallCheckListListFromServer", {
						isPassed: this.isPassed,
					});
				}
			},
			SavePassedValue(item) {
				this.$http.get("CheckList/SavePassedValue?id=" + item.checkListFolderId + "&value=" + !item.passed)
					.then(data => {
						var res = data.data.toString();

						if (res != "1") {
							document.getElementById(item.checkListFolderId).getElementsByTagName('input')[0].checked = false;
							this.showErrorMessage(res);
						} else {
							document.getElementById(item.checkListFolderId).remove();
						}

					});
			},
			LoadWallData() {
				this.$store.dispatch("GetWallCheckListListFromServer", {
					isPassed: this.isPassed,
				});
			},
			copyItem() {
				this.page = 1;
				if (this.listType == "fa-list" || this.listType == null || this.listType == "") {

					this.$store.dispatch("GetCheckListListFromServer", {
						pageId: this.page,
						filterId: this.filterId,
						userId: this.userId,
						projectId: this.projectId,
						searchKey: this.searchKey
					});
				} else if (this.listType == "fa-list-alt") {
					this.$store.dispatch("GetWallCheckListListFromServer", {
						isPassed: this.isPassed,
					});
				}
			},
			deleteCheckListFolder() {
				document.getElementsByClassName('menu-hider')[0].click();
				if (this.selectedFolcedrId != null) {
					VueSimpleAlert.confirm("آیا مایل به حذف این مورد هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
						this.$http.get("CheckList/DeleteFolderItem?id=" + this.selectedFolcedrId)
							.then(data => {
								var res = data.data.toString();
								if (res === "1") {
									document.getElementById(this.selectedFolcedrId).remove();
									this.showSuccessMessage("با موفقیت حذف شد.");
									this.selectedFolcedrId = null;
								}
								else {
									this.showErrorMessage(res);
								}
							});
					});
				}
			},
			deleteCheckList() {
				document.getElementsByClassName('menu-hider')[0].click();
				VueSimpleAlert.confirm("آیا مایل به حذف این چک لیست هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
					this.$http.get("CheckList/DeleteCheckList?id=" + this.selectedWorkId)
						.then(data => {
							var res = data.data.toString();
							if (res === "1") {
								this.showSuccessMessage("با موفقیت حذف شد.");
								this.page = 0;
								this.getNextPageForCheckListList();

							}
							else {
								this.showErrorMessage(res);
							}


						});
				});
			},
			Share() {
				document.getElementsByClassName("menu-hider")[0].click();
				VueSimpleAlert.confirm("آیا مایل به اشتراک گذاری این چک لیست هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
					this.pageLoading = true;
					setTimeout(function () { document.getElementsByClassName('menu-hider')[0].click(); }, 200)
					var data = {
						shareDoc: 4,
						id: this.selectedWorkId
					};
					this.$http.post("CheckList/ShareDoc", data)
						.then(data => {
							this.pageLoading = false;
							var res = data.data;
							if (res.isSuccess) {
								window.open(res.obj, '_blank');
							} else {
								this.showErrorMessage(res.message);
							}
						});

				});
			},
			copyCheckList() {
				document.getElementsByClassName('menu-hider')[0].click();
				VueSimpleAlert.confirm("آیا مایل به ثبت یک کپی از این چک لیست هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
					this.pageLoading = true;
					setTimeout(function () { document.getElementsByClassName('menu-hider')[0].click(); }, 200)

					this.$http.get("CheckList/CopyCheckList?id=" + this.selectedWorkId)
						.then(data => {
							var res = data.data;
							if (!isNaN(res)) {
								this.$router.push({ name: 'CreateCheckList', params: { checkListId: res } });
							}
							else {
								this.showErrorMessage(res);
							}
							this.pageLoading = false;

						});
				});
			},
			openDetails(checkListId) {
				this.$router.push({ name: 'CreateCheckList', params: { checkListId: checkListId } });
				document.getElementsByClassName('menu-hider')[0].click();
			},
			getNextPageForCheckListList() {
				if (this.listType == "fa-list" || this.listType == null || this.listType == "") {
					this.page++;
					this.$store.dispatch("GetCheckListListFromServer", {
						pageId: this.page,
						filterId: this.filterId,
						userId: this.userId,
						projectId: this.projectId,
						searchKey: this.searchKey,
						date: this.date
					});
				} else if (this.listType == "fa-list-alt") {
					this.$store.dispatch("GetWallCheckListListFromServer", {
						isPassed: this.isPassed,
					});
				}
			},
			selectDate(d) {
				this.date = d;
			},
			pauseVid(id) {
				if (id != null) {
					var vid = document.getElementById(id);
					vid.pause();
				}
			},
			pauseAllVid() {
				document.querySelectorAll('video').forEach(vid => vid.pause());
			},
		},
		activated() {
			this.showAddButton();
			if (this.UpdateCheckListList == true) {
				this.page = 0;
				this.getNextPageForCheckListList();
			}

		},
		mounted() {
			let checkListType = cookies.get('checkListShowType');
			if (checkListType != null && checkListType !== '')
				this.listType = checkListType;
			this.showAddButton();
			document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
		}
	};
</script>
